import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";

import { TemplateButtons, TemplateFooter, TemplateTexts, TemplateSubMessage } from "../TemplatePartials";
import TemplateMessageUtils from "../../../utils/classes/TemplateMessageUtils";

const useStyles = makeStyles((theme) => ({
  templateMainContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "1em",
  },

  templateSubMessageContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "7px",
    width: "100.00%",
  },

  templateTextsContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "7px",
  },

  templateButtonsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "7px",
    width: "100.00%",
  },
}));

const TemplateCustom = ({ message, ticketId, messageDataJson, templateType }) => {
  //  ***************
  //  ** Variables **
  //  ***************
  const classes = useStyles();
  const [templateData, setTemplateData] = useState(TemplateMessageUtils.DEFAULT_TEMPLATE_DATA);



  //  *****************
  //  ** Use Effects **
  //  *****************
  useEffect(() => {
    setTemplateData(TemplateMessageUtils.getTemplateData(message, messageDataJson, templateType));
  }, [message, messageDataJson, templateType]);



  //  ************
  //  ** Return **
  //  ************
  return (
    <div className={classes.templateMainContainer}>
      {messageDataJson && (templateData.subMessage.mediaUrl || templateData.subMessage.body) && (
        <div className={classes.templateSubMessageContainer}>
          <TemplateSubMessage
            type={templateData.subMessage.type}
            mediaUrl={templateData.subMessage.mediaUrl}
            body={templateData.subMessage.body}
            isDeleted={message.isDeleted}
          />
        </div>
      )}

      {(templateData.title || templateData.body) && (
        <div className={classes.templateTextsContainer}>
          <TemplateTexts title={templateData.title} body={templateData.body} />
        </div>
      )}

      {templateData.buttons && templateData.buttons.length > 0 && (
        <div className={classes.templateButtonsContainer}>
          <TemplateButtons
            buttons={templateData.buttons}
            message={message}
            ticketId={ticketId}
            isMinifiedPreview={false}
          />
        </div>
      )}

      {templateData.footer && (
        <div className={classes.templateTextsContainer}>
          <TemplateFooter footer={templateData.footer} />
        </div>
      )}
    </div>
  );
};

export default TemplateCustom;
